import {DynamicQuestionListHelper} from "@/helpers/DynamicQuestionListHelper";
import store from "@/store";

export default {

    data: () => {
        return {
            dynamicQuestion: null,
        }
    },
    methods : {
       async getNewDynamicQuestion(){
            window.console.log('GETTING NEW NEW');
            let dqi = await DynamicQuestionListHelper.getCurrentDynamicQuestion();
            window.console.log('THE QUESTION');
            window.console.log(dqi);
            if(dqi !== undefined){
                this.dynamicQuestion = dqi;
            }else{
                let userLang = store.state.userLanguage;
                this.dynamicQuestion = await DynamicQuestionListHelper.getDefaultQuestionJSONObject(userLang)['dynamic_questions'][0];
            }
            dqi = null;
        },
        /*getDQILabel(){
            window.console.log('getting label');
            window.console.log(this.dynamicQuestion);
            window.console.log('LABEL HERE !!!');
            window.console.log(this.dynamicQuestion.question)
            return this.dynamicQuestion.question;
        },
        computed : {
           dynamicQuestionLabel(){
               return (this.dynamicQuestion !== null && this.dynamicQuestion.question !== undefined)? this.dynamicQuestion.question : null;
           }

        }*/
    }
}